import * as React from 'react';
import { IconProps } from '../types';

const IcStar = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      d="m5.09 23 1.95-8.134L.5 9.395l8.64-.724L12.5 1l3.36 7.671 8.64.724-6.54 5.47L19.91 23l-7.41-4.313L5.09 23Z"
    />
  </svg>
);

export default IcStar;
